export const CommonFunction = () => {
  $(".js-header-toggle-button").on("click", () => {
    $(".js-header-toggle").toggleClass("is--open");
  });

  const header = document.getElementById("header");

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();

      // windowのwidthに応じてheaderの高さを取得
      let windowWidth = window.innerWidth;
      let headerHeight = windowWidth > 990 ? 40 : header.clientHeight + 40;

      // href属性のIDを取得
      const href = anchor.getAttribute("href");
      const target = document.getElementById(href.replace("#", ""));

      console.log(target.getBoundingClientRect().top);

      let targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    });
  });
};
